import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'safeHtml',
	standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
	constructor(
		private readonly sanitizer: DomSanitizer
	) {}

	public transform(value: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(value);
	}
}
